(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.stackCarousel = {
    attach: function (context, settings) {
      $(once('stackCarousel','.carousel', context)).each(function () {

        // The carousel navigation.
        var carouselNav = $(this).siblings('.carousel-nav--lozenges');

        // Initiate a new slider.
        const landing_slider = new SnapSlider(this, {
          nav: carouselNav,
          start: 'left',
          loop: true,
        });

        // Make the slider autoplay. Change the time in the 'setInterval' to make it slower/faster.
        // Currently set to 8 seconds.
        if ($(this).hasClass('carousel-autoplay')) {
          // When hovering over the carousel, stop the autoplaying. Note: tried using toggle here, but
          // it gave inconsistent results.
          $(this).hover(
            function(){
              $(this).addClass('carousel-hover');
            },
            function(){
              $(this).removeClass('carousel-hover');
            }
          );
          // Set the interval for the carousel to autoplay.
          setInterval(function () {
            if (!$(this).hasClass('carousel-hover')) {
              var nav = carouselNav;
              var currentItem = $(nav).find('.carousel-nav__button.is-current');
              var parentLi = $(currentItem).parent();
              if ($(parentLi).is(':last-child')) {
                var nextItem = $(parentLi).siblings('li:first');
              } else {
                var nextItem = $(parentLi).next();
              }
              if (nextItem.length) {
                $(nextItem).find('button').trigger('click');
              }
            }
          }.bind(this), 8000);
        }

      });

    }
  }
}(jQuery, Drupal));
